module.exports = __webpack_public_path__ + "static/img/index_produc_ico1.77cead88.png";